import Link from 'next/link'
import {useCallback} from 'react'

import {useBottomModal} from '@defign/ui'
import {useIsomorphicLayoutEffect} from '@financial/common-hooks'
import classNames from 'classnames/bind'

import NotDisplayedInsurancesLayer from '$components/insurance/my/detail/NotDisplayedInsurancesLayer'
import {INTERNAL_ROUTES} from '$constants/internal-routes'
import useHash from '$hooks/insurance/useHash'
import {useValidApp} from '$hooks/useValidApp'
import {sendClickNlog} from '$utils/nlog'

import Styles from './InsuranceDetailBottomInfo.module.scss'

const cx = classNames.bind(Styles)

const HASH_ID = '조회되지 않는 보험이 있나요'

export default function InsuranceDetailBottomInfo() {
    const {updateHash, isHashMatch, targetHashId} = useHash({
        hashId: HASH_ID,
    })
    const {open, close} = useBottomModal()
    const {isValidApp} = useValidApp()

    const openBottomModal = useCallback(() => {
        const onClose = () => {
            sendClickNlog('insumy.noclose')
            close()
            updateHash({hash: ''})
        }
        open({
            children: <NotDisplayedInsurancesLayer onClose={onClose} hashId={targetHashId} isValidApp={isValidApp} />,
            isShowCloseButton: true,
            onClickCloseButton: onClose,
            onClickDimmedLayer: onClose,
        })
    }, [close, open, targetHashId, updateHash, isValidApp])

    useIsomorphicLayoutEffect(() => {
        isHashMatch && setTimeout(openBottomModal, 0)
    }, [isHashMatch, openBottomModal])

    return (
        <>
            <div className={cx('article')}>
                <strong className={cx('title')}>안내드립니다</strong>
                <ul className={cx('list')}>
                    <li className={cx('item')}>
                        가입보험 정보는 마이데이터를 통한 각 보험사의 제공 정보를 기준으로 하며, 우리동네 무료보험은
                        국민재난안전포털 및 229개 지자체 홈페이지의 정보를 기준으로 제공됩니다.
                    </li>
                    <li className={cx('item')}>
                        내가 가입한 보험 중 일부가 조회되지 않을 수 있습니다. 혹시 등록되지 않은 보험상품이 있는지 잘
                        살펴봐주세요.
                        <br />
                        <a className={cx('link')} onClick={openBottomModal}>
                            조회되지 않은 보험 자세히 보기
                        </a>
                    </li>
                    <li className={cx('item')}>
                        보장 정보를 상품단위로도 확인할 수 있지만, 내가 가입한 전체 보험 기준으로 묶어볼 수 있어요.
                        동일한 보장에 얼마큼 가입했을까요?
                        <br />
                        <Link href={INTERNAL_ROUTES.INSURANCE_MY_COVERAGES} className={cx('link')}>
                            보장 요약 살펴보기
                        </Link>
                    </li>
                    <li className={cx('item')}>
                        보장금액은 약관에 따라 시간이 지나면 금액이 달라질 수 있어요. 만약 보장금액이 달라질 경우
                        ‘보장금액 변동’ 표시로 알려드려요.
                    </li>
                    <li className={cx('item')}>
                        내가 가입한 보장을 어떻게 활용하는 게 좋을지 알아보고 싶다면 다양한 보험정보를 확인해 보세요.
                        <br />
                        <Link href={INTERNAL_ROUTES.INSURANCE_CONTENTS} className={cx('link')}>
                            내 보험Tip 알아보기
                        </Link>
                    </li>
                </ul>
            </div>
        </>
    )
}
